// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { WALLET_RULE_KIND } from '../../constants/walletRuleKind';

export default class MerchantTerminalBalancesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicMerchantTerminalBalances';
        this.Server = this.props.context.getState().server.publicMerchantTerminalBalances;
        this.MenuDisplayType = 'menu';
        this.disableGlobalEditor = true;
        this.disableAdd = true;

        const defaultHead = [
            {
                id: 'merchantTerminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                from: 'publicMerchantTerminals',
                object: 'merchantTerminal',
                show: 'name',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'gatewayId',
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                from: 'publicGateways',
                object: 'gateway',
                show: 'name',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'direction',
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: WALLET_RULE_KIND,
                displayGrid: true,
                disableEditor: true
            },
            // The balance day comes as a number, 261022 for 22 Oct 2026.
            { id: 'date', label: 'date', alignRight: false, cell: 'Date', sourceFormat: 'YYMMDD', displayGrid: true, disableEditor: true },
            { id: 'hour', label: 'hour', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'countSuccess', label: 'countSuccess', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'countPending', label: 'countPending', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'countFailed', label: 'countFailed', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'totalSuccess', label: 'totalSuccess', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            { id: 'totalPending', label: 'totalPending', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            { id: 'totalFailed', label: 'totalFailed', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            // The same buckets summed from each transaction's balance amount, in
            // the balance currency — which is part of the row's key.
            {
                id: 'balanceCurrencyId',
                label: 'balanceCurrency',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencies',
                object: 'balanceCurrency',
                show: 'code',
                displayGrid: true,
                disableEditor: true
            },
            { id: 'balanceTotalSuccess', label: 'balanceTotalSuccess', alignRight: true, cell: 'Amount', currencyObject: 'balanceCurrency', displayGrid: true, disableEditor: true },
            { id: 'balanceTotalPending', label: 'balanceTotalPending', alignRight: true, cell: 'Amount', currencyObject: 'balanceCurrency', displayGrid: true, disableEditor: true },
            { id: 'balanceTotalFailed', label: 'balanceTotalFailed', alignRight: true, cell: 'Amount', currencyObject: 'balanceCurrency', displayGrid: true, disableEditor: true },
            { id: 'totalIncludedCommission', label: 'totalIncludedCommission', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            { id: 'totalOntopCommission', label: 'totalOntopCommission', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            { id: 'totalAgentCommission', label: 'totalAgentCommission', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            { id: 'commissionAgentJson', label: 'commissionAgentJson', alignRight: false, cell: 'Json', displayGrid: false, disableEditor: true },
            { id: 'commissionMerchantJson', label: 'commissionMerchantJson', alignRight: false, cell: 'Json', displayGrid: false, disableEditor: true },
            { id: 'commissionGwJson', label: 'commissionGwJson', alignRight: false, cell: 'Json', displayGrid: false, disableEditor: true }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
